/**
 * API base URL configuration.
 * When VITE_API_BASE_URL is set, API calls go directly to the backend (e.g. http://localhost:3001/api).
 * Otherwise, relative URLs (/api/...) are used and the Vite dev proxy forwards to the backend.
 */
function getApiBaseUrl(): string {
  try {
    const env = (import.meta as { env?: { VITE_API_BASE_URL?: string } }).env;
    const url = env?.VITE_API_BASE_URL;
    return url ? url.replace(/\/$/, '') : '';
  } catch {
    return '';
  }
}

/**
 * Resolve an API path to a full URL.
 * - When VITE_API_BASE_URL is set: returns full URL (e.g. http://localhost:3001/api/beds)
 * - Otherwise: returns path as-is for proxy (e.g. /api/beds)
 */
export function getApiUrl(path: string): string {
  const base = getApiBaseUrl();
  if (!base) return path;
  // base is e.g. http://localhost:3001/api; path is /api/beds -> /beds
  const suffix = path.startsWith('/api') ? path.slice(4) || '/' : path;
  return base + (suffix.startsWith('/') ? suffix : '/' + suffix);
}
